export const url = {
  MAIKURU_BASE_URL: import.meta.env.VITE_BASE_URL,
  NATIVE_BASE_URL: import.meta.env.VITE_NATIVE_BASE_URL,
  TAYORI_MAIKURU: import.meta.env.VITE_TAYORI_MAIKURU,
  MOBICON_API: import.meta.env.VITE_MOBICON_API,
  NEWS_RESOURCE_URL: import.meta.env.VITE_NEWS_RESOURCE_URL,
  MOBICON: import.meta.env.VITE_MOBICON,
} as const;
